module.exports = __webpack_public_path__ + "static/indigo-gardens-a3ba1749ad0d588d0fc294e91ed0938b.png";